import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { AppRoute, AdUnlockVariations } from '@chegg-wt/core/types/core'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { isWebRoute } from '@chegg-wt/core/utils/routes'
import { adUnlockVariationSelector } from '@chegg-wt/core/state/createCitation/selectors'

import { Config } from '@chegg-wt/core/config'
import { getCookie, Cookies } from '../utils/cookies'
import { navigated } from '../state/app/actions'
import { initializedSelector } from '../state/app/selectors'

export interface UseRedirectArgs {
  redirectRoute: AppRoute
  shouldRedirect: boolean
}

const useRedirect = ({ shouldRedirect, redirectRoute }: UseRedirectArgs) => {
  const cookieUserRole = getCookie(Cookies.UserRole)
  const dispatch = useDispatch()
  const { toLogin } = useRoutesContext()
  const initialized = useSelector(initializedSelector)
  const adUnlockModalExpVariant = useSelector(adUnlockVariationSelector)
  const showAdUnlockFirstVariant = adUnlockModalExpVariant === AdUnlockVariations.VARIANT1
  useEffect(() => {
    if (!shouldRedirect || (Config.adUnlockModalExperience && showAdUnlockFirstVariant)) {
      return
    }

    // We need to wait for initialization for a web route because we run the risk of
    // consuming the refresh token and leaving the app before the new token is set
    if (initialized || (cookieUserRole && !isWebRoute(redirectRoute))) {
      dispatch(navigated(redirectRoute))
    }
  }, [shouldRedirect, redirectRoute, initialized, cookieUserRole, dispatch, toLogin])
}

export default useRedirect
